
export default function (props) {
  let model = {
    percentProfileComplete () {
      let percentage = 40
      if (props.user_partner.bank_account_name !== null) {
        percentage += 6
      }
      if (props.user_partner.account_number !== null) {
        percentage += 6
      }
      if (props.user_partner.bank_name !== null) {
        percentage += 6
      }
      if (props.user_partner.bank_address !== null) {
        percentage += 6
      }
      if (props.user_partner.finance_year_start !== null) {
        percentage += 6
      }
      if (props.user_partner.org_aboutus !== null) {
        percentage += 10
      }
      if (props.user_partner.org_mission !== null) {
        percentage += 10
      }
      if (props.user_partner.org_image !== null) {
        percentage += 10
      }
      return percentage
    }
  }

  return Object.assign(props, model)
}



// WEBPACK FOOTER //
// ./src/models/user.js